<template>
  <div>
    <!-- ============= 검색 조건============= -->
    <ReportSurveySearch v-bind:queryParams="queryParams"
                     v-bind:fullDate="fullDate" />

    <ReportSurveyList v-bind:queryParams="queryParams"
                   v-bind:fullDate="fullDate" />
  </div>
</template>
<script>
import ReportSurveySearch from './component/ReportSurveySearch.vue';
import ReportSurveyList from './component/ReportSurveyList.vue';

export default {
  name: "reportSurveyManagementList",
  data() {
    return {
      fullDate: [],
      queryParams: {
        keyword: '',    // 검색 키워드
        status: [],     // 사용유무
        sites: [],      // 사이트
        categorys: [],  // 관심카테고리
        hashtags: [],   // 해시태그 유무
      },
    }
  },
  components: {
    ReportSurveySearch,
    ReportSurveyList,
  },
  methods: {
    getFormatDate(date) {
      if (!date) return;
      return moment(date).format("YYYY-MM-DD");
    },
  },
}
</script>
<style scoped>
.mx-datepicker{
  width : 100% !important;
}

table tr th, td {
  text-align: center;
}

.tdClass_tl { text-align: left; }
</style>



// WEBPACK FOOTER //
// src/views/contents/reportSurvey/ReportSurveyManagementList.vue